module.exports = __webpack_public_path__ + "static/media/ic-tick.9d747afc.svg";